export type FunnelEvent = 'menu_open' | 'cart_open' | 'order_sent' | 'order_paid';

const DEDUP_PREFIX = 'vot_funnel:';

/**
 * Шлёт событие воронки на сервер. Best-effort: ошибки тихо логируем,
 * не блокируем UX. Для часто-повторяемых событий (menu_open, cart_open)
 * есть локальный дедуп — одно событие на uid в сутки.
 */
export async function trackFunnel(
  event: FunnelEvent,
  opts: { uid?: string; dedupePerDay?: boolean } = {}
): Promise<void> {
  if (opts.dedupePerDay) {
    const today = new Date().toISOString().slice(0, 10);
    const key = `${DEDUP_PREFIX}${event}:${opts.uid || 'anon'}:${today}`;
    try {
      if (localStorage.getItem(key)) return;
      localStorage.setItem(key, '1');
    } catch {
      // localStorage может быть выключен (private mode iOS) — просто пропускаем дедуп
    }
  }
  try {
    await fetch('/api/funnel/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event }),
    });
  } catch {
    // тихо: телеметрия не должна никогда фейлить UX
  }
}
